import { render, staticRenderFns } from "./AboutTheNormPage.vue?vue&type=template&id=4069f981&"
import script from "./AboutTheNormPage.vue?vue&type=script&lang=js&"
export * from "./AboutTheNormPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports